import { RootState } from 'dde-app/app/redux/types';

const getLanguage = (state: RootState): string => state.i18nState.lang;

export {
  getLanguage,
};
